import { Stack, Typography } from '@mui/material';

import { CircularProgress } from '@hapvida/hapvida-core-components';

import { NEW_COLORS } from '@hapvida/hapvida-core-components/src/themes/colors/newColors';

import type { ReportButtonContentProps } from './types';
import { DownloadButton } from './styles';

export function ReportButtonContent({
  report,
  label,
  onDownload,
  onGenerateReport,
  loading,
}: Readonly<ReportButtonContentProps>) {
  return (
    <>
      <Stack flexDirection="row" alignItems="center">
        <Typography
          variant="text"
          color={report ? NEW_COLORS.GRAYSCALE[700] : NEW_COLORS.GRAYSCALE[300]}
          fontWeight={700}
        >
          {label}
        </Typography>
        {report.length > 0 && (
          <Typography variant="text">({report.length} arquivos)</Typography>
        )}
      </Stack>
      {report.length === 0 && (
        <DownloadButton
          variant="outlined"
          onClick={onGenerateReport}
          disabled={loading}
          type="button"
        >
          {loading ? (
            <Stack flexDirection="row" alignItems="center" gap={1}>
              Gerando relatório
              <CircularProgress
                size={12}
                progressColor={NEW_COLORS.GRAYSCALE[300]}
              />
            </Stack>
          ) : (
            <>Gerar relatório</>
          )}
        </DownloadButton>
      )}
      {report.length > 0 && (
        <DownloadButton
          variant="contained"
          color="success"
          onClick={onDownload}
          type="button"
        >
          Baixar relatório
        </DownloadButton>
      )}
    </>
  );
}
